/* eslint-disable no-mixed-spaces-and-tabs */
import { Button, FormLabel, MenuItem, Select, Stack } from '@mui/material';
import React, { useState } from 'react';
import { minimalLabelTheme } from '@/app/theme';
import { useSelector } from 'react-redux';
import { ProductGuidanceDrawer } from '@/components/Drawers/ProductGuidanceDrawer';
import { useGetUserDetailsQuery } from '@/features/user/userApi';
import { useGetGuidanceByClassOfRiskQuery } from '@/features/classesOfRisk/classesOfRiskApi';
import { NEEDS_ANALYSIS_LABELS } from '@/components/forms/CreateNewBusinessForm/validationSchema';

export const NeedsAnalysisSelect = ({
	analysisValue,
	label,
	classOfRisk, 
	disabled,
	setAnalysisValue,
	minimal,
	...props
}) => {
	const [openDialog, setOpenDialog] = useState(false);
	const account = useSelector((state) => state.msalAccount.account);
	const email = account?.username;

	const { data: userDetails } = useGetUserDetailsQuery(
		{ email },
		{ skip: !email }
	);

	// Query to check if guidance exists for this classOfRisk and broker group
	const { data: guidance } = useGetGuidanceByClassOfRiskQuery(
		{
			classOfRisk: classOfRisk,
			brokerGroupIds: userDetails?.brokerGroupArray || []
		},
		{ skip: !classOfRisk || !userDetails?.brokerGroupArray }
	);

	const handleOpenDialog = (event) => {
		event.preventDefault();
		setOpenDialog(true);
	};

	// Only show button if guidance exists
	const showGuidanceButton = guidance !== null && guidance !== undefined;

	return (
		<>
			<Stack
				direction='row'
				spacing={1}
				justifyContent={'space-between'}
				alignItems={'center'}
			>
				<FormLabel sx={minimal ? minimalLabelTheme : undefined}>{label}</FormLabel>
				{showGuidanceButton && (
					<Button
						variant='text'
						onClick={handleOpenDialog}
						sx={{ textTransform: 'none' }}
					>
						View guidance
					</Button>
				)}
			</Stack>
			<Select
				name='needsAnalysis'
				value={analysisValue}
				disabled={disabled}
				onChange={(e) => setAnalysisValue(e.target.value, e.target.name)}
				fullWidth
				{...props}
			>
				{Object.entries(NEEDS_ANALYSIS_LABELS).map(([value, displayLabel]) => (
					<MenuItem value={value} key={`needs-analysis-selection-${value}`}>
						{displayLabel}
					</MenuItem>
				))}
			</Select>
			<ProductGuidanceDrawer
				open={openDialog}
				handleClose={() => setOpenDialog(false)}
				classOfRisk={classOfRisk}
				label={label}
				brokerGroupIds={userDetails?.brokerGroupArray || []}
			/>
		</>
	);
};
